import Swal from "sweetalert2";

// Custom hook for showing the confirmation dialog
const useConfirmDialog = () => {
  const confirmAction = (config = {}, callback) => {
    const defaultConfig = {
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, do it!",
    };

    const finalConfig = { ...defaultConfig, ...config };

    Swal.fire(finalConfig).then((result) => {
      if (result.isConfirmed) {
        if (typeof callback === "function") {
          callback();
        }
      }
    });
  };

  return confirmAction;
};

export default useConfirmDialog;
